// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__UD+sJ","container":"ErrorPage_container__7K6Kz","errorBlock":"ErrorPage_errorBlock__qmuFv"};